import {FormatDate, FormatDateTime, FormatDateTimeBeforeSendToServer, FormatNumber} from '@/Helpers/Format';
import moment from "moment";

export default {
    data: () => ({
        listAllOrders: [],
        startBranches: [],
        selectedStartBranch: '',
        selectedStartBranchType: '',
        endBranches:[],
        selectedEndBranch:'',
        selectedEndBranchType: '',
        isLoading: false,
        count: 0,
        selectedDeliverType: '',
        // Value
        startDate: moment(new Date()).format('YYYY-MM-DD 00:00'),
        endDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
        searchItem: '',

        totalFreight: 0,
        totalPrice: 0,

        // Pagination
        offset: 10,
        pagination: {},
        per_page: 10,

        // The filters of the last "get data" click. Paging and export use these, so they always
        // match the table even when the form has been edited since.
        appliedFilters: null,
        latestFetchId: 0,

        //Export
        exporting: false,
        la_status_shipment_type: {
            'origin_freight_fees': 'ເກັບເງິນຕົ້ນທາງ',
            'destination_freight_fees': 'ເກັບເງິນ ( CDC )',
            'origin_freight_fees_cod': 'ເກັບເງິນ ( COD )',
            'destination_freight_fees_cod': 'ເກັບເງິນ ( COD & CDC )',
            'all': 'ທັງໝົດ'
        },
    }),
    methods: {
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date > today;
        },

        FormatDate(value) {
            return FormatDateTime(value);
        },
        FormatPrice(price) {
            if (price !== 0) {
                return FormatNumber(price);
            }
            return 0 + ' ກີບ';
        },

        GetData() {
            this.appliedFilters = {
                shipment_pay_type: this.$route.query.tab,
                start_branch: this.selectedStartBranch,
                end_branch: this.selectedEndBranch,
                startBranchType: this.selectedStartBranchType,
                endBranchType: this.selectedEndBranchType,
                deliverType: this.selectedDeliverType,
                shipment_number: this.searchItem,
                startDate: this.startDate,
                endDate: this.endDate,
            };
            // Old rows go now: export and paging must not act on the new filters while showing these.
            this.ClearResults();
            this.pagination.current_page = 1;
            this.FetchData();
        },

        FetchData() {
            // A slow answer from an earlier click or another tab must not fill this table.
            const fetchId = ++this.latestFetchId;
            this.isLoading = true;
            this.$http.get('list-shipment/pre-order', {
                params: {
                    ...this.appliedFilters,
                    page: this.pagination.current_page,
                    per_page: this.per_page,
                }
            }).then((res) => {
                if (fetchId !== this.latestFetchId) {
                    return;
                }
                this.listAllOrders = res.data.shipments.data;
                this.pagination = res.data.shipments;
                this.count = res.data.shipments.total;
                this.totalFreight = res.data.totalFreight;
                this.totalPrice = res.data.totalPrice;
                this.isLoading = false;
            }).catch((error) => {
                if (fetchId !== this.latestFetchId) {
                    return;
                }
                this.isLoading = false;
                this.ShowError(error.response && error.response.data && error.response.data.message);
            });
        },

        ExportExcel() {
            if (this.listAllOrders.length <= 0 || this.exporting) {
                return;
            }
            const filters = this.appliedFilters;
            this.exporting = true;
            this.$http.post('list-shipment/pre-order/export', filters, {responseType: 'blob'})
                .then((response) => {
                    const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileUrl;
                    fileLink.setAttribute('download', this.ExportFileName(filters));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(fileUrl);
                    this.exporting = false;
                })
                .catch((error) => {
                    this.exporting = false;
                    this.ShowExportError(error);
                });
        },

        ExportFileName(filters) {
            const title = 'ລາຍການອໍເດີ Pre-Order ' + this.la_status_shipment_type[filters.shipment_pay_type] + ' ປະຈຳວັນທີ ';
            if (FormatDateTimeBeforeSendToServer(filters.startDate) === FormatDateTimeBeforeSendToServer(filters.endDate)) {
                return title + FormatDate(filters.startDate) + '.xlsx';
            }
            return title + FormatDate(filters.startDate) + ' ຫາວັນທີ ' + FormatDate(filters.endDate) + '.xlsx';
        },

        // With responseType 'blob' the error JSON also arrives as a Blob.
        ShowExportError(error) {
            const body = error.response && error.response.data;
            if (!(body instanceof Blob)) {
                this.ShowError();
                return;
            }
            body.text()
                .then((text) => this.ShowError(JSON.parse(text).message))
                .catch(() => this.ShowError());
        },

        ShowError(message) {
            this.$notification.OpenNotification_Error('top-right', 'danger', 4000,
                message || 'ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ');
        },

        FetchListStartBranch() {
            this.$http.get('v1/listing/' + 'branches' + '?type=' + this.selectedStartBranchType + '&include=excluded').then((res) => {
                this.startBranches = res.data;
                this.startBranches.unshift({
                    id: "",
                    name: 'ທັງໝົດ'
                });
            })
        },

        FetchListEndBranch() {
            this.$http.get('v1/listing/' + 'branches' + '?type=' + this.selectedEndBranchType + '&include=excluded').then((res) => {
                this.endBranches = res.data;
                this.endBranches.unshift({
                    id: "",
                    name: 'ທັງໝົດ'
                });
            })
        },

        ClearData() {
            this.startDate = moment(new Date()).format('YYYY-MM-DD 00:00');
            this.endDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
            this.selectedStartBranch = '';
            this.selectedEndBranch = '';
            this.searchItem = '';
            this.selectedDeliverType = '';
            this.selectedEndBranchType = '';
            this.selectedStartBranchType = '';
            this.FetchListStartBranch();
            this.FetchListEndBranch();

            // Back to the waiting state; drop any request still running.
            this.latestFetchId++;
            this.isLoading = false;
            this.appliedFilters = null;
            this.ClearResults();
        },

        ClearResults() {
            this.listAllOrders = [];
            this.pagination = {};
            this.count = 0;
            this.totalFreight = 0;
            this.totalPrice = 0;
        },
    },
    watch: {
        'selectedStartBranchType': function () {
            this.FetchListStartBranch();
        },
        'selectedEndBranchType': function () {
            this.FetchListEndBranch();
        }
    }
}
